// extracted by mini-css-extract-plugin
export default {"modalSuccess":"Success_modalSuccess__4XW74"};